import { render, staticRenderFns } from "./LKRoadmapsFeedIndex.vue?vue&type=template&id=1c90accd&"
import script from "./LKRoadmapsFeedIndex.vue?vue&type=script&lang=js&"
export * from "./LKRoadmapsFeedIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports